import FilterIconDark from "assets/imgs/icons/filter_icon_dark.svg";
import axios from "axios";
import FilterDropdown from "components/FilterDropdown/FilterDropdown";
import SearchInput from "components/SearchInput/SearchInput";
import debounce from "lodash.debounce";
import { forwardRef, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes";
import searchCourses from "service/courses/search-course";
import "./globalSearch.scss";

// custom filter toggler
const filterToggler = forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className="globalSearch__filter_btn h-100 d-flex align-items-center justify-content-center"
  >
    <img src={FilterIconDark} alt="" />
  </button>
));

const FilterIconButton = () => {
  return <FilterDropdown toggler={filterToggler} />;
};

function GlobalSearch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  const [cancelToken, setCancelToken] = useState();
  const debouncedSearch = useCallback(
    debounce(async (value) => {
      if (typeof cancelToken !== "undefined") {
        cancelToken.cancel();
      }

      if (value === "") return;

      setCancelToken(axios.CancelToken.source());
      try {
        const courses = await searchCourses(value, cancelToken);
        const res = [];

        for (let i = 0; i < courses?.length; i++) {
          res.push({ label: courses[i].groupName, value: courses[i].groupId });
        }

        setSearchResults(res);
      } catch (error) {
        console.log(error);
      } finally {
        setCancelToken(undefined);
      }
    }, 250),
    []
  );
  return (
    <SearchInput
      className="w-100 text-center global-search-input"
      placeholder="Find Your Course"
      rounded={true}
      appendItem={<FilterIconButton />}
      variant="primary_white"
      value={searchTerm}
      data={searchResults}
      onChange={(v) => {
        if (typeof v === "number") return;
        setSearchTerm(v);
        debouncedSearch(v);
      }}
      onSelect={(v, { label }) =>
        navigate(ROUTES.SEARCH_RESULTS, {
          state: { id: v, course: label },
        })
      }
    />
  );
}

export default GlobalSearch;
